<template>
  <v-card flat tile>
    <!-- <v-card-title>
      <span class="headline">Sign Up</span>
    </v-card-title> -->
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Display Name*"
              v-model="displayName"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Email*"
              v-model="email"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="password"
              label="Password*"
              type="password"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="image"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Pick an image"
              prepend-icon="mdi-camera"
              label="Profile Photo"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-container>
      <!-- <small>*indicates required field</small> -->
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        text
        @click="emitDialogClosed"
        aria-label="Close button"
        >Close</v-btn
      >
      <v-btn
        x-large
        color="primary"
        type="submit"
        @click="signUp()"
        aria-label="Sign up button"
        >Sign Up</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'SignUp',
  data: () => ({
    displayName: '',
    photoURL: '',
    email: '',
    password: '',
    image: null,
  }),
  methods: {
    emitDialogClosed() {
      this.$emit('dialog-closed', false);
    },
    signUp() {
      const user = {
        displayName: this.displayName,
        photoURL: this.photoURL,
        email: this.email,
        password: this.password,
      };
      this.$store.dispatch('signUpAction', user);
    },
  },
};
</script>
